import type { ApiClient } from './client';

// ANX-045 — admin-only листинг audit_log записей tenant'а.

export interface AuditLogEntry {
  id: string;
  tenantId: string | null;
  actorType: 'operator' | 'system' | 'admin' | 'visitor';
  actorId: string | null;
  action: string;
  targetType: string | null;
  targetId: string | null;
  metadata: unknown;
  ip: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface ListAuditLogFilter {
  action?: string;
  actorId?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
}

export interface ListAuditLogResult {
  entries: AuditLogEntry[];
  nextCursor: string;
}

interface AuditLogEntryRaw {
  id: string;
  tenant_id: string | null;
  actor_type: 'operator' | 'system' | 'admin' | 'visitor';
  actor_id: string | null;
  action: string;
  target_type: string | null;
  target_id: string | null;
  metadata: unknown;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
}

function toEntry(r: AuditLogEntryRaw): AuditLogEntry {
  return {
    id: r.id,
    tenantId: r.tenant_id,
    actorType: r.actor_type,
    actorId: r.actor_id,
    action: r.action,
    targetType: r.target_type,
    targetId: r.target_id,
    metadata: r.metadata,
    ip: r.ip,
    userAgent: r.user_agent,
    createdAt: r.created_at,
  };
}

export async function listAuditLog(
  client: ApiClient,
  filter: ListAuditLogFilter = {},
): Promise<ListAuditLogResult> {
  const params = new URLSearchParams();
  if (filter.action) params.set('action', filter.action);
  if (filter.actorId) params.set('actor_id', filter.actorId);
  if (filter.from) params.set('from', filter.from);
  if (filter.to) params.set('to', filter.to);
  if (filter.limit) params.set('limit', String(filter.limit));
  if (filter.cursor) params.set('cursor', filter.cursor);
  const qs = params.toString();
  const url = '/api/v1/audit_logs' + (qs ? '?' + qs : '');
  const raw = await client.request<{ entries: AuditLogEntryRaw[]; next_cursor: string }>(url);
  return {
    entries: raw.entries.map(toEntry),
    nextCursor: raw.next_cursor,
  };
}
